module.exports = __webpack_public_path__ + "img/dialogClose.08e4379f.svg";